export const salesSummaryConstants = {
  ROW_TYPE_1: 1,
  ROW_TYPE_2: 2,
  ROW_TYPE_3: 3,
};
